
import axios from "axios";

export const getWheel = () => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get(`${process.env.REACT_APP_API_HOST}/wheel`)
        .then(
          (response) => {
            resolve(response.data); // Resolve with the data from the response
          })
        .catch((err) => {
          reject(err); // Reject with the error
        });
    } catch (error) {
      reject(error); // If there's an error in the try block, reject the Promise
    }
  });
};


export const spinWheelResult = () => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get(`${process.env.REACT_APP_API_HOST}/wheel/spin`)
        .then(
          (response) => {
            resolve(response.data); // Resolve with the data from the response
          })
        .catch((err) => {
          reject(err); // Reject with the error
        });
    } catch (error) {
      reject(error); // If there's an error in the try block, reject the Promise
    }
  });
};

export const getWheelInfo = () => {
  return new Promise((resolve, reject) => {
    try {
      axios
        .get(`${process.env.REACT_APP_API_HOST}/wheel/spin-info`)
        .then(
          (response) => {
            resolve(response.data); // Resolve with the data from the response
          })
        .catch((err) => {
          console.log(err)
          reject(err); // Reject with the error
        });
    } catch (error) {
      console.log(error)
      reject(error); 
    }
  });
};


export const getUIConfig = async (uiConfigId) => {
  try {
    const response = await fetch(`https://jiokbc.akamaized.net/ipl2020test${process.env.REACT_APP_ENVIRONMENT=="dev" ? `-${process.env.REACT_APP_ENVIRONMENT}` : ''}/configs/${uiConfigId}.json`);
    // Check if the response is ok (status code 200)
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    
    // Parse the JSON and return it
    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error fetching UI config:', error);
    return null; // or handle as appropriate
  }
};